import type { WorkspaceState } from "./types";
import { upcomingOccurrences } from "./time";

export function maintainWorkspaceSchedule(
  state: WorkspaceState,
  now: string,
): string[] {
  if (state.tenant.mode === "sample") return [];
  const changed: string[] = [];
  const nowMs = Date.parse(now);
  for (const session of state.sessions) {
    const nextState =
      Date.parse(session.endsAt) <= nowMs
        ? "completed"
        : Date.parse(session.startsAt) <= nowMs
          ? "in_progress"
          : "scheduled";
    if (session.state !== nextState) {
      session.state = nextState;
      session.revision += 1;
      changed.push(session.id);
    }
  }
  for (const candidate of state.makeups) {
    if (
      candidate.bookedSessionId === null &&
      candidate.eligibility === "eligible" &&
      Date.parse(candidate.expiresAt) <= nowMs
    ) {
      candidate.eligibility = "ineligible";
      candidate.reason = "보강 신청 기한이 지나 후보를 닫았어요.";
      candidate.revision += 1;
      changed.push(candidate.id);
    }
  }
  for (const classGroup of state.classes) {
    const occurrences = upcomingOccurrences(
      now,
      state.tenant.timezone,
      classGroup.weekdays,
      classGroup.startTime,
      classGroup.endTime,
    );
    for (const occurrence of occurrences) {
      const sessionId = `session-${classGroup.id}-${occurrence.dateKey}`;
      let session = state.sessions.find((item) => item.id === sessionId);
      if (!session) {
        session = {
          id: sessionId,
          classId: classGroup.id,
          startsAt: occurrence.startsAt,
          endsAt: occurrence.endsAt,
          state: occurrence.state,
          revision: 1,
        };
        state.sessions.push(session);
        changed.push(sessionId);
      }
      for (const studentId of classGroup.studentIds) {
        if (
          state.attendance.some(
            (record) =>
              record.sessionId === sessionId && record.studentId === studentId,
          )
        )
          continue;
        const attendanceId = `attendance-${sessionId}-${studentId}`;
        state.attendance.push({
          id: attendanceId,
          sessionId,
          studentId,
          status: "unmarked",
          recordedAt: null,
          source: "server",
          syncState: "idle",
          version: 1,
        });
        changed.push(attendanceId);
      }
    }
  }
  for (const session of state.sessions) {
    if (session.state !== "completed") continue;
    const classGroup = state.classes.find((item) => item.id === session.classId);
    const compensationKrw = classGroup?.compensationKrw ?? 0;
    if (
      !classGroup ||
      compensationKrw <= 0 ||
      state.compensation.some((item) => item.sessionId === session.id)
    )
      continue;
    const candidateId = `compensation-${session.id}`;
    state.compensation.push({
      id: candidateId,
      instructorId: classGroup.instructorId,
      sessionId: session.id,
      ruleVersion: "class-rate-v1",
      amountKrw: compensationKrw,
      reason: `${classGroup.name} 완료 수업 · 반 설정 회당 수당`,
      state: "candidate",
      approvedAt: null,
    });
    changed.push(candidateId);
  }
  return changed;
}
